<template>
  <div class="halloween">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 内容 -->
    <div class="halloween-c">
      <!-- banner -->
      <div class="h-banner">
        <img
          src="../assets/images/Christmas_banner_bg1.png"
          :alt="this.$t('message.wstag')"
        />
        <div class="h-bf">
          <img src="../assets/images/Christmas_banner_title.png" alt="" />
          <h1 :class="{ hCH: show1, hEN: show2 }">
            {{ $t("message.christmas.h1") }}
          </h1>
          <h3>{{ $t("message.christmas.h2") }}</h3>
          <el-button type="primary">
            <template v-if="this.$i18n.locale === 'zh'">
              <router-link
                :to="{ path: '/menu/', params: { lang: this.$i18n.locale } }"
                >{{ $t("message.christmas.btn") }}</router-link
              >
            </template>
            <template v-else>
              <router-link
                :to="{ path: '/en/menu/', params: { lang: this.$i18n.locale } }"
                >{{ $t("message.christmas.btn") }}</router-link
              >
            </template>
          </el-button>
        </div>
      </div>
      <!-- 必选 -->
      <div class="bx">
        <div :class="{ f2CH: show1, f2EN: show2, bx_top: show3 }">
          <div>
            <h2>{{ $t("message.christmas.section2h2") }}</h2>
          </div>
        </div>
        <div class="bx-bottom">
          <div>
            <div>
              <div>
                <img src="../assets/images/Christmas2_content1_img1.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.christmas.section2h3_1") }}</h3>
                <p>{{ $t("message.christmas.section2p1") }}</p>
              </div>
            </div>
            <div>
              <div>
                <img src="../assets/images/Christmas2_content1_img2.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.christmas.section2h3_2") }}</h3>
                <p>{{ $t("message.christmas.section2p2") }}</p>
              </div>
            </div>
            <div>
              <div>
                <img src="../assets/images/Christmas2_content1_img3.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.christmas.section2h3_3") }}</h3>
                <p>{{ $t("message.christmas.section2p3") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 联系 -->
      <div class="h-call">
        <div :class="{ f3CH: show1, f3EN: show2, 'hcall-top': show3 }">
          <div>
            <h2>{{ $t("message.christmas.section3h2") }}</h2>
          </div>
        </div>
        <div class="hcall-bottom">
          <div>
            <h2>{{ $t("message.christmas.tip") }}</h2
            ><br /><span>{{ $t("message.christmas.section3p") }}</span>
          </div>
          <el-button class="goca">
            <a
              style="text-decoration: none"
              href="https://api.whatsapp.com/send?phone=85264586539&text=hello%20%E5%88%B0%E6%9C%83%E5%AE%B6,%E6%88%91%E6%83%B3%E8%A8%82%E5%88%B0%E6%9C%83%EF%BC%81%F0%9F%98%8B%F0%9F%98%8B"
              target="_black"
              >WhatsApp Order</a
            >
            <i class="iconfont icon-whatsapp"></i>
          </el-button>
        </div>
      </div>
    </div>
    <div class="activity-contanier">
      <div class="activity-main">
        <Title style="color:#fa3d17;text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white" :title="$t('message.christmas.context.h2TitleOne')"></Title>
        <Content color="#FFFFFF" :content="$t('message.christmas.context.pContentOne')"></Content>
        <Content color="#FFFFFF" :content="$t('message.christmas.context.pContentOneSecond')"></Content>
      </div>
    </div>
    <div class="faq-contanier">
      <div class="faq-main">
        <Title style="color:#fa3d17;text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white" :title="$t('message.christmas.aboutChristmasTitle')"></Title>
        <div class="feq-content">
          <div class="about-food-main">
            <div v-for="item in 3" :key="item" style="margin-left:10px">
              <h3 style="color:#fa3d17;text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white">{{ $t(`message.christmas.aboutChristmas.faq${item}`) }}</h3>
              <div style="margin-left:10px" class="feq-content-text">
                {{ $t(`message.christmas.aboutChristmas.content${item}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <!-- 菜单 -->
    <el-dialog :visible.sync="dialogVisible" class="menuPic">
      <img :src="imgs" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import header from "../components/header";
import Title from './common/title.vue'
import Content from './common/content.vue'
export default {
  name: "halloween",
  data() {
    return {
      dialogVisible: false,
      show1: true,
      show2: false,
      show3: true,
      imgs: require("../assets/images/Christmas_Menu_CN.png")
    };
  },
  components: {
    "v-header": header,
    Title,
    Content
  },
  mounted() {
    if (this.$i18n.locale === "zh") {
      this.show2 = false;
      this.show1 = true;
      this.imgs = require("../assets/images/Christmas_Menu_CN.png");
    } else {
      this.show1 = false;
      this.show2 = true;
      this.imgs = require("../assets/images/Christmas_Menu_En.png");
    }
  },
  methods: {
    open() {
      this.dialogVisible = true;
    }
  },
  updated() {
    if (this.$i18n.locale === "zh") {
      this.show2 = false;
      this.show1 = true;
      this.imgs = require("../assets/images/Christmas_Menu_CN.png");
    } else {
      this.show1 = false;
      this.show2 = true;
      this.imgs = require("../assets/images/Christmas_Menu_En.png");
    }
  }
};
</script>

<style lang="less" scoped>
.activity-contanier {
  background-image: none;
  .activity-main {
    width: 70%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }
    .content{
      color:#FFFFFF !important;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.faq-contanier {
  .faq-main {
    width: 70%;
    margin: 0 auto;
    padding:30px 0;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .feq-content {
      margin: 0 0 3%;
      font-size: .825rem;
      color: #FFFFFF;

      .feq-content-text {
        margin-bottom: 3%;
      }
    }

  }
}
.halloween .menuPic img {
  width: 100%;
}
.halloween {
  background: url("../assets/images/Christmas_bg.png");
}
.halloween .halloween-c {
  margin: 110px 0 0 0;
}
.halloween .h-banner {
  position: relative;
  display: flex;
}
.halloween .h-banner > img {
  height: 100%;
  width: 100%;
}
.halloween .h-banner .h-bf {
  position: absolute;
  width: 100%;
  margin: auto;
  border-radius: 5px;
  padding: 5% 0;
  text-align: center;
  color: #fff;
}
.halloween .h-banner .h-bf img {
  width: 20%;
}
.halloween .h-banner .h-bf button {
  font-weight: 600;
  color: #096f34;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
  font-size: 20px;
  width: 200px;
  border: none;
  background-image: linear-gradient(#ffcf3b, #fdb12a);
}
.halloween .h-banner .h-bf button a {
  display: block;
  color: #096f34;
  text-decoration: none;
}
.halloween .h-banner .h-bf .hCH {
  margin: auto;
  width: 50%;
  letter-spacing: 8px;
  color: #096f34;
  font-size: 4vw;
  font-weight: bold;
  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */
  text-shadow: 4px 0px 8px rgba(59, 0, 0, 0.6);
  -webkit-text-stroke: 0.7px #ffffff;
}
.halloween .h-banner .h-bf .hEN {
  margin: auto;
  width: 50%;
  letter-spacing: 1px;
  color: #096f34;
  font-size: 4vw;
  font-weight: bold;
  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */
  text-shadow: 4px 0px 8px rgba(59, 0, 0, 0.6);
  -webkit-text-stroke: 0.1px #ffffff;
}
.halloween .h-banner .h-bf h3 {
  width: 50%;
  font-size: 2vw;
  font-weight: 400;
  letter-spacing: 8px;
  margin: 3% auto;
}
.halloween .qf,
.halloween .bx,
.halloween .h-call {
  width: 70%;
  margin: 6% auto;
}
.halloween .qf .qf-top > div,
.halloween .bx .bx_top > div,
.halloween .h-call .hcall-top > div {
  margin: auto;
  height: 75px;
  background-image: url("../assets/images/chbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  color: #fff;
}
.halloween .qf .qf-top .f1CH {
  font-size: 0.82vw;
}
.halloween .qf .qf-top .f1EN {
  font-size: 0.7vw;
}
.halloween .bx .f2CH {
  font-size: 0.82vw;
}
.halloween .bx .f2EN {
  font-size: 0.7vw;
}
.halloween .h-call .f3CH {
  font-size: 0.8vw;
}
.halloween .h-call .f3EN {
  font-size: 0.65vw;
}
.halloween .qf .qf-top > div,
.halloween .bx .bx_top > div {
  width: 450px;
}
.halloween .h-call .hcall-top > div {
  width: 450px;
}
.halloween .qf .qf-top > div h2,
.halloween .bx .bx_top > div h2,
.halloween .h-call .hcall-top > div h2 {
  position: absolute;
  left: 30%;
  top: 38%;
}
.halloween .qf-bottom {
  margin: 5% auto;
  background-image: url("../assets/images/Christmas1_bg1.png");
  background-size: 100% 100%;
  width: 80%;
}
.halloween .bx-bottom {
  margin: 5% 0;
}
.halloween .qf-bottom > div,
.halloween .bx-bottom > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.halloween .qf-bottom > div > div {
  padding: 8% 2% 4% 4%;
  box-sizing: border-box;
}
.halloween .qf-bottom > div > div:nth-child(1) {
  flex: 0 0 45%;
  text-align: center;
}
.halloween .qf-bottom > div > div:nth-child(2) {
  flex: 0 0 55%;
  text-align: center;
}
.halloween .qf-bottom > div > div:nth-child(1) {
  padding: 20px 20px 15px 13%;
  color: #fff;
}
.halloween .qf-bottom > div > div:nth-child(1) h1 {
  font-size: 2vw;
  color: #fa3d17;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.halloween .qf-bottom > div > div:nth-child(1) span {
  margin: 5px 0 10% 0;
  display: block;
  font-size: 15px;
}
.halloween .qf-bottom > div > div:nth-child(1) button span {
  margin: 0;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.halloween .qf-bottom > div > div:nth-child(1) li {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.halloween .qf-bottom > div > div:nth-child(1) button {
  border: none;
  margin: 10px 0 0 0;
  color: #096f34;
  width: 200px;
  background-image: linear-gradient(#ffcf3b, #fdb12a);
}
.halloween .qf-bottom > div > div:nth-child(1) button a {
  text-decoration: none;
  color: #096f34;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
}
.halloween .qf-bottom > div > div:nth-child(2) img {
  width: 60%;
  height: 100%;
}
.halloween .bx-bottom > div > div {
  flex: 0 0 32%;
  /* background: #fc8817; */
  background-image: url("../assets/images/Christmas2_content1_bg.png");
  background-size: 100% 100%;
  padding: 77px 15px 32px 18px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
}
.halloween .bx-bottom img {
  width: 70%;
  height: 100%;
}
.halloween .bx-bottom h3 {
  /* font-family: FZCYJ; */
  margin: 10px 0;
}
.halloween .bx-bottom p {
  width: 80%;
  font-size: 14px;
  margin: auto;
}
.halloween .hcall-bottom {
  margin: 5% 0 0 0;
  padding: 5% 13%;
  background: url("../assets/images/Christmas3_bg.png");
  background-size: 100% 100%;
  text-align: center;
}
.halloween .hcall-bottom > div:nth-child(1) {
  color: #fff;
  font-size: 22px;
  margin: 30px 0;
  line-height: 40px;
}
.halloween .hcall-bottom > div:nth-child(1) h2:nth-child(1) {
  color: #fa3d17;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.halloween .hcall-bottom button {
  border: none;
  color: #096f34;
  font-weight: bold;
  font-size: 20px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#ffcf3b),
    to(#fdb12a)
  );
  background-image: linear-gradient(#ffcf3b, #fdb12a);
  margin: 0 0 20px 0;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.halloween .hcall-bottom button i {
  font-size: 20px;
}
.halloween .goca span,
.halloween .goca a {
  /* display: block; */
  height: 100%;
  color: #096f34;
}
.halloween .qf.f > .qf-bottom > div {
  align-items: center;
}
/* 移动端 */
@media (max-width: 1676px) {
  .halloween .qf .qf-top .f1CH {
    font-size: 1.1vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 0.8vw;
  }
  .halloween .bx .f2CH {
    font-size: 1.1vw;
  }
  .halloween .bx .f2EN {
    font-size: 0.8vw;
  }
  .halloween .h-call .f3CH {
    font-size: 0.91vw;
  }
  .halloween .h-call .f3EN {
    font-size: 0.75vw;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 1.5vw;
  }
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 2.2vw;
  }
  .halloween .qf-bottom > div > div:nth-child(1) {
    padding: 20px 0px 15px 13%;
  }
}
@media (max-width: 1550px) {
  .halloween .h-call .f3EN {
    font-size: 0.8vw;
  }
}
@media (max-width: 1450px) {
  .halloween .qf .qf-top .f1CH {
    font-size: 1.1vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1vw;
  }
  .halloween .bx .f2CH {
    font-size: 1vw;
  }
  .halloween .bx .f2EN {
    font-size: 0.9vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1vw;
  }
  .halloween .h-call .f3EN {
    font-size: 0.85vw;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 80%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 2.5vw;
  }
}
@media (max-width: 1350px) {
  .halloween .h-call .f3EN {
    font-size: 0.9vw;
  }
}
@media (max-width: 1250px) {
  .halloween .qf .qf-top .f1CH {
    font-size: 1.3vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1.1vw;
  }
  .halloween .bx .f2CH {
    font-size: 1.5vw;
  }
  .halloween .bx .f2EN {
    font-size: 1vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.2vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1vw;
  }
}
@media (max-width: 1200px) {
  .halloween .qf .qf-top > div {
    font-size: 1.3vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.22vw;
  }
  .halloween .bx .f2EN {
    font-size: 1.1vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1vw;
  }
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 2.5vw;
  }
}
@media (max-width: 1100px) {
  .halloween .h-call .f3EN {
    font-size: 1.1vw;
  }
}
@media (max-width: 1050px) {
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 2.8vw;
  }
  .halloween .qf .qf-top .f1CH {
    font-size: 1.5vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1.4vw;
  }
  .halloween .bx .f2CH {
    font-size: 1.6vw;
  }
  .halloween .bx .f2EN {
    font-size: 1.3vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.35vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1.2vw;
  }
  .halloween .h-banner .h-bf h1 {
    font-size: 5vw;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 1.7vw;
    letter-spacing: 4px;
  }
  .halloween .hcall-bottom > p:nth-child(2) {
    width: 50%;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 90%;
  }
}
@media (max-width: 1000px) {
  .halloween .qf .qf-top .f1CH {
    font-size: 1.6vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1.4vw;
  }
  .halloween .bx .f2CH {
    font-size: 1.7vw;
  }
  .halloween .bx .f2EN {
    font-size: 1.4vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.5vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1.2vw;
  }
}
@media (max-width: 950px) {
  .halloween .h-call .f3EN {
    font-size: 1.26vw;
  }
}
@media (max-width: 860px) {
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 3.5vw;
  }
  .halloween .qf .qf-top > div {
    font-size: 1.7vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1.6vw;
  }
  .halloween .bx .f2CH {
    font-size: 1.9vw;
  }
  .halloween .bx .f2EN {
    font-size: 1.5vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.7vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1.4vw;
  }
  .halloween .qf-bottom {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .halloween .halloween-c {
    margin: 135px 0 0 0;
  }
  .halloween .h-banner .h-bf h1 {
    font-size: 4vw;
    letter-spacing: 4px;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 2.5vw;
    letter-spacing: 2px;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 90%;
  }
  .halloween .h-banner .h-bf h1,
  .halloween .h-banner .h-bf h3 {
    width: 80%;
    letter-spacing: 5px;
    margin-bottom: 20px;
  }
  .halloween .qf-bottom > div > div:nth-child(1) button {
    width: 80%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) li {
    font-size: 14px;
  }
  .halloween .qf-bottom > div > div:nth-child(1) span {
    font-size: 12px;
  }
  .halloween .qf .qf-top .f1CH {
    font-size: 2vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 1.8vw;
  }
  .halloween .bx .f2CH {
    font-size: 2vw;
  }
  .halloween .bx .f2EN {
    font-size: 1.7vw;
  }
  .halloween .h-call .f3CH {
    font-size: 1.5vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1.6vw;
  }
  .halloween .h-banner .h-bf h1 {
    -webkit-text-stroke: 1px #ffffff;
  }
  .halloween .qf-bottom {
    width: 100%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) {
    padding: 35px 0px 20px 10%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 3.8vw;
  }
  .halloween .bx-bottom > div > div {
    flex: 0 0 100%;
  }
}
@media (max-width: 650px) {
  .halloween .h-call .f3CH {
    font-size: 2.2vw;
  }
  .halloween .h-call .f3EN {
    font-size: 1.9vw;
  }
}
@media (max-width: 550px) {
  .halloween .bx .f2EN {
    font-size: 2.3vw;
  }
  .halloween .h-call .f3CH {
    font-size: 2.2vw;
  }
  .halloween .h-call .f3EN {
    font-size: 2.2vw;
  }
}
@media (max-width: 480px) {
  .halloween .qf-bottom > div > div:nth-child(1) button a,
  .halloween .goca span,
  .halloween .goca a {
    font-size: 16px;
  }
  .halloween .qf .qf-top > div,
  .halloween .bx .bx_top > div,
  .halloween .h-call .hcall-top > div {
    height: 50px;
  }
  .halloween .qf-bottom > div > div:nth-child(1) button {
    width: auto;
    height: 40px;
    width: 150px;
    line-height: 11px;
  }
  .halloween .el-dialog {
    width: 100%;
    margin: 20% 0;
  }
  .halloween .el-dialog img {
    width: 100%;
  }
  .halloween .h-banner .h-bf img {
    width: 42%;
    height: 100%;
  }
  .halloween .h-banner {
    height: 250px;
  }
  .halloween .h-banner .h-bf button {
    font-size: 16px;
    width: 150px;
  }
  .halloween .h-banner .h-bf h1,
  .halloween .h-banner .h-bf h3 {
    width: 95%;
    font-size: 10vw;
    letter-spacing: 4px;
  }
  .halloween .hcall-bottom button {
    width: 200px;
    height: 47px;
  }
  .halloween .h-banner .h-bf {
    width: 100%;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 14px;
    letter-spacing: 2px;
    margin-bottom: 10px;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 90%;
  }
  .halloween .qf .qf-top > div,
  .halloween .bx .bx_top > div,
  .halloween .h-call .hcall-top > div {
    width: 100%;
  }
  .halloween .qf .qf-top > div h2,
  .halloween .bx .bx_top > div h2,
  .halloween .h-call .hcall-top > div h2 {
    top: 38%;
  }
  .halloween .qf-bottom > div > div {
    flex: 0 0 100%;
  }
  .halloween .qf-bottom > div > div {
    padding-top: 23px;
  }
  .halloween .qf-bottom > div > div:nth-child(2) {
    padding: 0px 15px 20px 15px;
  }
  .halloween .qf-bottom > div > div:nth-child(2) p {
    font-size: 15px;
  }
  .halloween .bx-bottom > div > div {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .halloween .bx-bottom > div > div > div:nth-child(2) {
    padding: 0 25px;
  }
  .halloween .hcall-bottom {
    padding: 20px 20px;
  }
  .halloween .hcall-bottom > p:nth-child(2) {
    width: 90%;
  }
  .halloween .qf .qf-top .f1CH {
    font-size: 2.8vw;
  }
  .halloween .qf .qf-top .f1EN {
    font-size: 2.3vw;
  }
  .halloween .bx .f2CH {
    font-size: 2.8vw;
  }
  .halloween .bx .f2EN {
    font-size: 2.3vw;
  }
  .halloween .h-call .f3CH {
    font-size: 2.8vw;
  }
  .halloween .h-call .f3EN {
    font-size: 2.4vw;
  }
  .halloween .qf-bottom {
    width: 100%;
  }
  .halloween .qf-bottom > div > div:nth-child(1),
  .halloween .qf-bottom > div > div:nth-child(2) {
    flex: 0 0 100%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) {
    margin: 30% 0 0 0;
  }
  .halloween .qf-bottom > div > div:nth-child(1) {
    padding: 0 5% 20px 5%;
  }
  .halloween .qf-bottom > div > div:nth-child(1) h1 {
    font-size: 8vw;
  }
  .halloween .h-banner .h-bf h3 {
    margin-top: 0;
  }
  .halloween .qf-bottom > div > div:nth-child(2) img {
    width: 90%;
    height: 300px;
  }
  .halloween .qf-bottom > div > div:nth-child(1) span {
    margin: 5px 0 2% 0;
  }
  .halloween .hcall-bottom > p:nth-child(1) {
    margin: 25% 0 20px 0;
    line-height: 30px;
    font-size: 20px;
  }
  @media (max-width: 360px) {
    .halloween .h-call .f3EN {
      font-size: 2vw;
    }
  }
}
</style>
